import { useCallback, useState } from 'react';
import { guardedClient } from '../../../auth/api/clients';
import {
  BulkCreateCustomerItem,
  BulkCreateCustomersResponse,
  bulkCreateCustomersResponseSchema,
} from '@minutes-system/backend/src/api/customers/schema';
import fetchAndValidate from '../../../../lib/fetchAndValidate';
import { refreshAllCustomersCache } from '../../../../states/statesUtil';

interface UseCreateCustomersReturn {
  results: BulkCreateCustomersResponse | null;
  createCustomers: (data: BulkCreateCustomerItem[]) => Promise<BulkCreateCustomersResponse>;
}

const useCreateCustomers = (): UseCreateCustomersReturn => {
  const [results, setResults] = useState<BulkCreateCustomersResponse | null>(null);

  const createCustomers = useCallback(
    async (data: BulkCreateCustomerItem[]) => {
      const response = await guardedClient.customers.$post({ json: data });
      const validated = await fetchAndValidate(Promise.resolve(response), bulkCreateCustomersResponseSchema);
      refreshAllCustomersCache();
      setResults(validated);
      return validated;
    },
    [setResults]
  );

  return { results, createCustomers };
};

export default useCreateCustomers;
